var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.445,13.661c-5.328,.033-8.195,2.91-8.292,8.321-.005,.269,.099,.527,.287,.719,.188,.191,.444,.299,.713,.299h14.595c.269,0,.525-.107,.713-.299,.188-.191,.292-.45,.287-.719-.092-5.332-3.036-8.287-8.303-8.321Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.515,12l.892-.893c.586-.586,.586-1.535,0-2.121s-1.535-.586-2.121,0l-.892,.892-.892-.892c-.586-.586-1.535-.586-2.121,0s-.586,1.535,0,2.121l.892,.893-.892,.893c-.586,.586-.586,1.535,0,2.121,.293,.293,.677,.439,1.061,.439s.768-.146,1.061-.439l.892-.892,.892,.892c.293,.293,.677,.439,1.061,.439s.768-.146,1.061-.439c.586-.586,.586-1.535,0-2.121l-.892-.893Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.457,12.309c3.611-.021,5.555-1.971,5.622-5.671-.062-3.56-2.111-5.614-5.634-5.637-3.561,.022-5.622,2.122-5.622,5.672s2.062,5.615,5.634,5.636Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDelete);
export default __webpack_public_path__ + "static/media/user-delete.437f584cf1127efe71be9168b87528e9.svg";
export { ForwardRef as ReactComponent };